export const RESPONSIVE_DRAWER_HEIGHT = 64; // The unit is px
export const RESPONSIVE_DRAWER_WIDTH = 300; // The unit is px
export const DETAILVIEW_TOOLBAR_HEIGHT = 3; // The unit is rem

export const EWC_CLASSES: { class: string; label: string }[] = [
  { class: '150101', label: 'paper_cardboard' },
  { class: '160103', label: 'tyres' },
  { class: '1704', label: 'metal' },
  { class: '170101', label: 'concrete' },
  { class: '170102', label: 'brick_tile' },
  { class: '170103', label: 'ceramic' },
  { class: '170107', label: 'mixed_mineralic_waste' },
  { class: '170201', label: 'wood' },
  { class: '170202', label: 'glass' },
  { class: '170302', label: 'bitumen' },
  { class: '170504', label: 'gravel' },
  { class: '170504', label: 'soil' },
  { class: '170504', label: 'stones' },
  { class: '170508', label: 'track_ballast' },
  { class: '170604', label: 'insulation' },
  { class: '170604', label: 'styrofoam' },
  { class: '170802', label: 'gypsum' },
  { class: '170904', label: 'mixed_construction_waste' },
  { class: '200201', label: 'biodegradable' },
  { class: '200301', label: 'mixed_municipal_waste' },
];
